import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useToast, useFetch, useModal, useGrid, usePopup, useResource, usePage } from "@/comn/hooks";
import { APIS_COMN, SF_COMN_BLL_INFO, SF_COMN_BLL_SRCH } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";
import { APIS } from "./services/OsciBllReusService"; // 서비스

/*
 * Bill Detail
 * !== 고지 상세 ==!
 */
export const OSCI0403007S = () => {
    const resource = useResource({
        defaultSchema: [],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { bllMgmtId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const popup = usePopup();
    const { scrnId } = useParams();
    let pgeTitle = "T_BLL_INFO";

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0023" },
            { area: "comnCd", comnCd: "OSC0166" },
            { area: "coCd" },
            { area: "bnkCd" },
        ],
    });

    const [vsbBll, setVsbBll] = useState(false);

    /*
     * @ 화면에서 사용하는 form 객체를 선언
     * @ 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * @ 검색 조건일 경우 구분을 위해 폼 이름 뒤에 Srch
     * @ const form = {
     *      [form 이름] : useForm({
     *          defaultSchema: [form의 schema 구조],
     *          defaultValues: [form의 기본 값] || {},
     *      }),
     *      ...
     * }
     */

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Bill Search !== 고지 검색 ==!
        bllSrch: useForm({
            defaultSchema: SF_COMN_BLL_SRCH,
            defaultValues: {},
        }),
        // Bill General !== 고지 일반 ==!
        bllGnrl: useForm({
            defaultSchema: SF_COMN_BLL_INFO,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const readyFunc = {
        noData: () => {
            form.bllGnrl.clearValues();
        },
        resetView: () => {
            setVsbBll(false);
        },
        readyBll: (data: any) => {
            form.bllGnrl.setValues({
                ...data.bllInfo.content,
            });

            form.bllSrch.setValues({
                ...data.bllInfo.content,
            });

            if (data.bllInfo.content != null) {
                setVsbBll(true);
            }

            if (data.bllInfo.content.reffKeyTpCd == null || data.bllInfo.content.reffKeyTpCd == "") {
                form.bllGnrl.setValue("reffKey", "");
            } else {
                if (data.bllInfo.content.reffKeyNo1) {
                    if (data.bllInfo.content.reffKeyTpCd == "T" || data.bllInfo.content.reffKeyTpCd == "B") {
                        form.bllGnrl.setValue(
                            "reffKey",
                            data.bllInfo.content.reffKeyNo1 +
                                "-" +
                                data.bllInfo.content.reffKeyNo2 +
                                "-" +
                                data.bllInfo.content.reffKeyNo3,
                        );
                    } else if (data.bllInfo.content.reffKeyTpCd == "A") {
                        form.bllGnrl.setValue("reffKey", data.bllInfo.content.reffKeyNo1);
                    } else {
                        if (data.bllInfo.content.reffKeyNo4 == null || data.bllInfo.content.reffKeyNo4 == "") {
                            form.bllGnrl.setValue(
                                "reffKey",
                                data.bllInfo.content.reffKeyNo1 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo2 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo3,
                            );
                        } else {
                            form.bllGnrl.setValue(
                                "reffKey",
                                data.bllInfo.content.reffKeyNo1 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo2 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo3 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo4,
                            );
                        }
                    }
                }
            }

            if (data.bllInfo.content.dcltNm != null && data.bllInfo.content.dcltNm != "") {
                form.bllGnrl.setValue(
                    "dcltTinNm",
                    colUtils.setMask(data.bllInfo.content.dcltTin, "tin") + " (" + data.bllInfo.content.dcltNm + ")",
                );
            } else {
                form.bllGnrl.setValue("dcltTinNm", colUtils.setMask(data.bllInfo.content.dcltTin, "tin"));
            }

            if (data.bllInfo.content.exppnImppnNm != null && data.bllInfo.content.exppnImppnNm != "") {
                form.bllGnrl.setValue(
                    "exppnImppnTinNm",
                    colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin") +
                        " (" +
                        data.bllInfo.content.exppnImppnNm +
                        ")",
                );
            } else {
                form.bllGnrl.setValue("exppnImppnTinNm", colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin"));
            }

            if (data.bllInfo.content.pyerTpCd == "T") {
                if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                    form.bllGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.bllInfo.content.pyerNm +
                            ")",
                    );
                } else {
                    form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                }
            } else {
                if (data.bllInfo.content.pyerMgmtNo == null || data.bllInfo.content.pyerMgmtNo == "") {
                    form.bllGnrl.setValue("pyerMgmtNoNm", data.bllInfo.content.pyerNm);
                } else {
                    if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                        form.bllGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.bllInfo.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                    }
                }
            }

            if (data.bllInfo.content.bllRgsrId && data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue(
                    "bllRgsrIdNm",
                    data.bllInfo.content.bllRgsrId + "/" + data.bllInfo.content.bllRgsrNm,
                );
            } else if (data.bllInfo.content.bllRgsrId) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrId);
            } else if (data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrNm);
            }
        },
    };

    const fetch = {
        // Get Bill !== 고지 조회 ==!
        getBllDtlInfo: useFetch({
            api: (data) => APIS.getBllDtlInfo(bllMgmtId),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                if (data.bllInfo.content != null) {
                    readyFunc.readyBll(data);
                } else {
                    toast.showToast({ type: "warning", content: "msg.osc.00050" });
                    readyFunc.noData();
                }
            },
            onError: (error) => {},
            showToast: true,
        }),
    };
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {};

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllMgmtId: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
    };

    useEffect(() => {
        form.bllSrch.setEditable(false);
        form.bllGnrl.setEditable(false);
        form.bllGnrl.setSchema("feeAmt", { edit: true });
    }, []);

    return (
        <Page title={t(pgeTitle)}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control
                                    {...form.bllSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.bllSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.bllSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.bllSrch.setValue("bllYy", data.substring(5, 7));
                                        form.bllSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.bllSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllDgr} />
                            </Group.Field>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {vsbBll && (
                <>
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllNo} />
                                    <Group.Control {...form.bllGnrl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.ctrlNo} />
                                    <Group.Control {...form.bllGnrl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllTpCdSec} />
                                    <Group.Control {...form.bllGnrl.schema.bllStatCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.pyerMgmtNoNm} />
                                    <Group.Control {...form.bllGnrl.schema.bllRgsrIdNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.reffKeyTpCd} />
                                    <Group.Control {...form.bllGnrl.schema.reffKey} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.feeAmt} />
                                    <Group.Control {...form.bllGnrl.schema.currCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.payDdlnDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsDt} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                </>
            )}
            {comnUtils.isPopup() && (
                <Layout direction="row">
                    <Layout.Right>
                        <Button
                            role="close"
                            onClick={() => {
                                popup.close();
                            }}
                        ></Button>
                    </Layout.Right>
                </Layout>
            )}
        </Page>
    );
};
